let hash: string;

/**
 * If init.js is a file then we take its cache buster
 */
export function getInitVersion(): string | undefined {
    if (typeof document === 'undefined') {
        return '';
    }
    if (hash === undefined) {
        const initElement = document.head.querySelector('script[src*="assets/js/init.js"]');

        hash = '';
        if (initElement) {
            const initSrc = initElement.getAttribute('src');
            if (initSrc) {
                hash = initSrc.replace(/.*\.js/, '');
            }
        }
    }
    return hash;
}
